import { File } from './File.js';
/**
 * A list associated with a file query.
 *
 * @public
 */
export class FileList {
    constructor(book, payload) {
        this.book = book;
        this.payload = payload || {};
    }
    /**
     * Gets the cursor associated with the query for pagination.
     *
     * @returns The cursor associated with the query for pagination
     */
    getCursor() {
        return this.payload.cursor;
    }
    /**
     * Gets the first File in the list.
     *
     * @returns The first File in the list
     */
    getFirst() {
        const files = this.getItems();
        return files.length > 0 ? files[0] : undefined;
    }
    /**
     * Gets the total number of files in the list.
     *
     * @returns The total number of files
     */
    size() {
        var _a;
        return ((_a = this.payload.items) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
    /**
     * Gets the files in the list.
     *
     * @returns An array of File objects
     */
    getItems() {
        var _a;
        const files = [];
        for (const file of (_a = this.payload.items) !== null && _a !== void 0 ? _a : []) {
            files.push(new File(this.book, file));
        }
        return files;
    }
}
//# sourceMappingURL=FileList.js.map